import * as React from "react";
import { config } from "../../../config/domain";
import EdModal from "../../generic/edModal";
import Loader from "../../generic/loader";
import { asyncGetServiceRequest } from "../../service/postLogin/clientProfileAPIService";
import {
  CreateServiceRequestDetails,
  ServiceClientValidation,
} from "../../service/serviceRequest/srApiService";
interface ConsentPopupProps {
  type: string;
  onClose?: () => void;
}
const consentTypes = [
  {
    name: "email",
    description:
      "Please update email in order to avoid deactivation of account",
    enableCross: false,
    showBtn: true,
    title: "Update your contact details!",
  },
  {
    name: "mobile",
    description:
      "Please update mobile number in order to avoid deactivation of account",
    enableCross: false,
    showBtn: true,
    title: "Update your contact details!",
  },
  {
    name: "emailMob",
    description:
      "Please update email & mobile number in order to avoid deactivation of account",
    enableCross: false,
    showBtn: true,
    title: "Update your contact details!",
  },
  {
    name: "pan",
    description:
      "It seems PAN is not valid. Please process new account in offline. Please contact your RM/ Customer service for the same.",
    enableCross: true,
    showBtn: false,
    title: "PAN invalid",
  },
  {
    name: "name",
    description:
      "Account is deactivated due to incorrect name. Please contact your RM/ Customer Service and update name in our records.",
    enableCross: true,
    showBtn: false,
    title: "Name mismatch in records!",
  },
  {
    name: "nominee",
    description:
      "As per SEBI guidelines, it is mandatory to update nominee details in your account.",
    enableCross: true,
    hintText:
      "You need to either nominate (Opt-in) OR Opt-out of nomination. If the nomination details are not updated by 31'st March 2023, your account will be deactivated as per regulations.",
    showBtn: true,
    title: "Nomination Required",
    instructText:"Click on the Proceed button to nominate online."
    
  },
];

export const ConsentPopupScreen = (props: ConsentPopupProps) => {
  const [loader, setLoader] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);
  const [existingSr, setExistingSr] = React.useState<boolean>(false);

  function redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  }
  React.useEffect(() => {
    return () => {};
  }, []);
  let consentDet = consentTypes.filter((ele) => {
    return ele.name === props.type;
  })[0];

  const onSubmit = async () => {
    try {
      if (consentDet.name === "nominee")
        redirect(
          config.root +
            "/clientarea/service-request/nomination?consentType=" +
            consentDet.name
        );
      else {
        setLoader(true);
        const payload = {
          requestType: "Account Reactivation",
          dpID: "None",
        };
        const serviceList = await asyncGetServiceRequest();
        const sr = serviceList.filter(
          (srReq: any) =>
            srReq.RequestType === "Equity Dormant Reactivation" &&
            [
              "Draft Saved",
              "Submitted",
              "AssignedtoHO",
              "InProcess",
              "PendingforEsign",
              "EsignVerified",
              "EsignSubmitted",
              "AssignedforEsignQC",
              "EsignVerified",
              "PushToTarget",
              "MemorandumPaymentPending",
            ].includes(srReq.RequestStatus)
        )[0];
        let response = await ServiceClientValidation({
          subType: "Equity Dormant Reactivation",
        });
        if (response === "BOAcoountNumber not found") {
          const accReact = await CreateServiceRequestDetails(payload);

          if (
            typeof accReact === "string" &&
            accReact.includes("Previous Request already open for this account-")
          ) {
            setLoader(false);
            redirect(
              config.root +
                "/clientarea/service-request/account-reactivation?consentType=" +
                consentDet.name
            );
          } else {
            if (accReact && accReact.Message)
              localStorage.setItem(
                "accReactParentDetails",
                JSON.stringify(accReact)
              );
            else {
              setLoader(false);
              setError(true);
              return;
            }
          }
        } else {
          localStorage.setItem("accReactParentDetails", JSON.stringify(sr));
        }
        setLoader(false);
        redirect(
          config.root +
            "/clientarea/service-request/account-reactivation?consentType=" +
            consentDet.name
        );
      }
    } catch (err) {
      setLoader(false);
      setError(true);
    }
  };
  function ModalBody(): React.ReactElement {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn income-declaration-phase1 consentPopup">
        <div className="modal-content">
          {loader ? (
            <div
              style={{
                textAlign: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <Loader size={50} color="blue"></Loader>
            </div>
          ) : (
            <div className="modal-body ">
              {!error && (
                <div className="finalScreen consentPopup exclamateConsent">
                  {consentDet.enableCross && (
                    <div>
                      <a
                        role="button"
                        //href="#"
                        onClick={props.onClose}
                        title="Close"
                        className="exclamateConsent-cancel"
                      >
                        <i className="edel-icon-close"></i>
                      </a>
                    </div>
                  )}

                  <div className="inProgress_wrap">
                    <div className="inProgress">
                      {consentDet.name === "nominee" ? (
                        <i className="edel-icon-nomination-sr"></i>
                      ) : (
                        <i className="edel-icon-exclamation"></i>
                      )}
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">{consentDet.title}</p>
                  </div>
                  <div>
                    <p className="field-subHead desc text-center">
                      {consentDet.description}
                    </p>
                  </div>
                  {consentDet.hintText && (
                    <>
                      <br />
                      <div>
                        <p className="field-subHead desc text-center">
                          {consentDet.hintText}
                        </p>
                      </div>
                    </>
                  )}
                  {consentDet.instructText && (
                    <>
                      <br />
                      <div>
                        <p className="field-subHead desc text-center">
                          {consentDet.instructText}
                        </p>
                      </div>
                    </>
                  )}

                  {consentDet.showBtn && (
                    <div>
                      <div className="fullWidthBtn">
                        <button
                          className="ed_button button submit_btn primary primary_border active"
                          onClick={() => {
                            if (
                              consentDet.name.includes("email") ||
                              consentDet.name.includes("mobile") ||
                              consentDet.name.includes("nominee")
                            )
                              onSubmit();
                          }}
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {error && (
                <div className="finalScreen consentPopup">
                  <div>
                    <a
                      role="button"
                      //href="#"
                      onClick={props.onClose}
                      title="Close"
                      className="exclamateConsent-cancel"
                    >
                      <i className="edel-icon-close"></i>
                    </a>
                  </div>
                  <div className="">
                    <div className="icon-wrap">
                      <i className="edel-icon-blocked"></i>
                    </div>
                  </div>
                  <div>
                    <p className="field-head text-center">
                      {!existingSr
                        ? "Technical Issue"
                        : "Error while creating SR"}
                    </p>
                  </div>
                  <div>
                    <p className="field-subHead desc text-center grey-text">
                      {!existingSr
                        ? "Facing Some Technical Issue.Please Try Again Later."
                        : "You already have active service request."}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
  return <EdModal show={true} close={() => {}} children={ModalBody()} />;
};
